import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px;
  justify-content: center;
  align-items: center;
`

export const StyledButton = styled.button`
  display: flex;
  width: 100%;
  border: none;
  :hover {
    cursor: pointer;
  }
  background-color: transparent;
`

export const Icon = styled.div`
  display: flex;
  padding-right: 5px;
`
export const TextContainer = styled.div`
  color: white;
`
export const Menu = styled.div`
  background-color: #242323;
  color: white;
`
